import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

import roadmap from './roadmap'
import banners from './banners'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules: {
    roadmap,
    banners,
  },
}
